import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button, SelectField, SwitchField} from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import Loadingmini from '../components/loadingmini';

export default function Userpersonalinsurance({userJwt, userId, fleetCode}) {
  const roundBack = (date,hours) => {
    date.setHours(date.getHours() - hours);
    date.setMinutes(0, 0, 0);
    return date;
  }
  const [is_loading, updateIsLoading] = React.useState(false);
  const [docUrl, updateDocUrl] = React.useState(false);
  const [myerror, updateMyerror] = React.useState(false);
  const [mysuccess, updateMySuccess] = React.useState(false);
  const [showOptions, updateShowOptions] = React.useState(false);
  const [showUploadDoc, updateShowUploadDoc] = React.useState(false);
	const [selectedFile, setSelectedFile] = useState();
  const [presigned_url, updatePresignedUrl] = React.useState("");
  const [new_document_name, updateNewDocumentName] = React.useState("");
	const [isSelected, setIsSelected] = useState(false);
  const [count, setCount] = useState(0);
  const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",resp:[]})
  const [coverageType, updateCoverageType] = React.useState("");
  const [insurance_effective_datetime, updateEffectiveDate] = useState(roundBack(new Date(),12));
  const [insurance_expiration_datetime, updateExpirationDate] = useState(roundBack(new Date(),12));
  const [includeDocDetails, updateIncludeDocDetails] = React.useState(true);


  const columns = [
    {
      headerName: 'File Name',
      field: 'insurance_image_key',
      filter: true,
      cellRenderer: params => {
          let val = params.value
          let link = '../userpersonalinsurancedoc/' + String(val) 
          return( <NavLink to={link} index = {val}>{val}</NavLink>)
      }
    },
    {
      headerName: 'Fleet Code',
      field: 'fleet_code',
      filter: true
    },
    {
      headerName: 'Uploaded by',
      field: 'uploaded_image_by_user_id',
      filter: true,
      cellRenderer: params => {
          let val = params.value
          let link = '../' + String(val) + '/'
          return(<NavLink
            to={link}
            onClick={e => {
              e.preventDefault();
              window.open(link, "_blank", "noopener,noreferrer");
            }}
          >
            {val}
          </NavLink>)
      }
    },
    {
      headerName: 'Uploaded By',
      field: 'uploaded_image_by_full_name',
      filter: true
    },
    {
      headerName: 'Uploaded Date',
      field: 'uploaded_image_datetime',
      filter: true
    },
    {
      headerName: 'Effective Date',
      field: 'effective_date',
      filter: true
    },
    {
      headerName: 'Expiration Date',
      field: 'expiration_date',
      filter: true
    },
    {
      headerName: 'Fleet Sign-Off By',
      field: 'signed_off_fleet_user_id',
      filter: true,
      cellRenderer: params => {
          let val = params.value
          let link = '../' + String(val) + '/'
          return(<NavLink
            to={link}
            onClick={e => {
              e.preventDefault();
              window.open(link, "_blank", "noopener,noreferrer");
            }}
          >
            {val}
          </NavLink>)
      }
    },
    {
      headerName: 'Fleet Sign-Off By',
      field: 'signed_off_fleet_user_id',
      filter: true
    },
    {
      headerName: 'Fleet Sign-Off Timestamp',
      field: 'signed_off_fleet_timestamp',
      filter: true
    },
    {
      headerName: 'Status',
      field: 'status',
      filter: true
    }
  ];

  async function submitDoc() {
    updateIsLoading(true);
    updateShowUploadDoc(false);
    console.log('submitting document...')
    if(!isSelected)
    {
      updateMyerror("Please select a file before submitting.")
      updateIsLoading(false);
      return;
    }
    fetch(presigned_url, {
        method:'PUT',
        body:selectedFile,
        headers: {
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Origin': '*'
        }
    }).then((res) => {
        console.log('res:'+JSON.stringify(res))

        if(includeDocDetails)
        {
          // EFFECTIVE - Get date components
          var year = insurance_effective_datetime.getFullYear();
          var month = String(insurance_effective_datetime.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
          var day = String(insurance_effective_datetime.getDate()).padStart(2, '0');
          // EFFECTIVE - Format the string
          var effectiveDatetimeString = `${year}-${month}-${day}`;
  
          // EXPIRATION - Get date components
          year = insurance_expiration_datetime.getFullYear();
          month = String(insurance_expiration_datetime.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
          day = String(insurance_expiration_datetime.getDate()).padStart(2, '0');
          // EXPIRATION - Format the string
          var expirationDatetimeString = `${year}-${month}-${day}`;
          var myInit = {queryStringParameters:{ 
              back_end: process.env.REACT_APP_BACKEND, 
              jwt:userJwt, 
              api_endpoint: "api3:portal:driver_desk",
              section: "insurance",
              request_type: "POST",
              document_name: new_document_name,
              driver_id: userId,
              fleet_code:fleetCode,
              method:"upload",
              coverage_type: coverageType,
              effective_date: effectiveDatetimeString,
              expiration_date: expirationDatetimeString
  
          }};
        } else {
          var myInit = {queryStringParameters:{ 
              back_end: process.env.REACT_APP_BACKEND, 
              jwt:userJwt, 
              api_endpoint: "api3:portal:driver_desk",
              section: "insurance",
              request_type: "POST",
              document_name: new_document_name,
              driver_id: userId,
              fleet_code:fleetCode,
              method:"upload"
          }};
        }
        //console.log('myInit:'+JSON.stringify(myInit))
        try {
            API.get('adminWebTools','/ago',myInit).then((res3) => {
                console.log(JSON.stringify(res3))
                if('detail' in res3)
                {
                  var statusString = "Error uploading file "+new_document_name+" for driver "+userId+" fleet "+fleetCode+": " + res3['detail'];
                  updateMyerror(statusString);
                } else {
                  //updateMySuccess(true)
                  var newCount = count + 1;
                  setCount(newCount);
                }
            });
        } catch (e) {
            var statusString = "Error uploading file: " + e;
            updateMyerror(statusString);
        }
    })
    updateIsLoading(false);
  }

	const updateFile = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsSelected(true);
	};

  async function getPresignedUrl() {
    //console.log('getting document presigned url for user '+userId+', fleetcode '+fleetCode+'...')
    updateIsLoading(true)
    //console.log('userpersonalinsurance fleet code:  fleetCode');
    const myInit = {queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:userJwt,
        api_endpoint:"api3:portal:driver_desk",
        section:"insurance",
        request_type:"GET",
        driver_id: userId,
        fleet_code:fleetCode
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        //console.log(JSON.stringify(res))
        updateRes(res);
        updatePresignedUrl(res["presigned_url_upload"]);
        updateNewDocumentName(res["new_document_name"]);
        updateMyerror(false);
    }
    catch (e) {
        const errorMessage = e?.response?.data?.detail
          ?? e?.message
          ?? JSON.stringify(e);
        updateMyerror("Error loading personal insurance: " + errorMessage);
    }
    updateIsLoading(false)
  }

  async function getImageUrl() {
    updateIsLoading(true)
    console.log('getting image url...')
    const myInit = {queryStringParameters:{ 
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:userJwt,
        api_endpoint:"api3:portal:driver_desk",
        section:"insurance",
        request_type:"GET",
        driver_id: userId,
        fleet:fleetCode
    }};
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        console.log(JSON.stringify(res))
        
        updateDocUrl(res['presigned_url_view'])
        updateShowUploadDoc(false);
        updateMyerror(false)
        updateMySuccess(false)
        updateIsLoading(false)
        return
    }
    catch (e) {
        console.log(JSON.stringify(e))
        updateMyerror(JSON.stringify(e));
        updateIsLoading(false)
        return
    }
  }


  useEffect(() => {
    getPresignedUrl();
  },[count])

  return (
    is_loading ? <Loadingmini /> : 
      <Flex
        direction="column"
      >
        <Heading level={2}>Personal Insurance</Heading>
        <Text style={{width:'100%'}}>History of uploads and approvals of the driver's personal insurance card(s)</Text>
        <View>
            <Button onClick={() => setCount(count + 1)}>
                PRESS TO GET LATEST UPDATES
            </Button>
        </View>
        <Divider />
        <Text><i>Hint: To search, long-click on mobile or click top-right on pc.</i></Text>
        <View style={{width:"100%"}}>
            <View 
                theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                style={{ height: 500 }} // the grid will fill the size of the parent container
            >
                    <AgGridReact
                        rowData={res.resp}
                        columnDefs={columns}
                        rowSelection={multiRowSelection}
                        paginationPageSize={500}
                        paginationPageSizeSelector={[10, 25, 50]}
                        enableCellTextSelection={true}
                    />
            </View>
        </View>




        <View style={{width:"100%"}}>
          <Flex direction="column" gap="1rem" >
            <Flex direction="column">
                { myerror ? <View>
                          <Heading level={4}>Whoops!</Heading>
                          <Text>We ran into an error processing your request:</Text>
                          <Text>{myerror}</Text>
                        <Button onClick={() => getImageUrl()}>TRY AGAIN</Button>
                    </View>
                  :
                  mysuccess ? <View>
                          <Heading level={4}>Success!</Heading>
                          <Text>Your file has been uploaded.</Text>
                        <Button onClick={() => getImageUrl()}>VIEW FILE</Button>
                    </View>
                  : showUploadDoc ?
                    <View>
                      <Heading level={2}>Upload File</Heading>
                      <input type="file" name="file" onChange={updateFile} accept=".jpg, .png, .jpeg, .pdf" />
                      {isSelected ? (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}>
                          <Text>Filename: {selectedFile.name}</Text>
                          <Text>Filetype: {selectedFile.type}</Text>
                          <Text>Size in bytes: {selectedFile.size}</Text>
                          <Text>
                            lastModifiedDate:{' '}
                            {selectedFile?.lastModifiedDate
                              ? selectedFile.lastModifiedDate.toLocaleDateString()
                              : "N/A"}
                          </Text>
                        </View>
                      ) : (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}><Text>Select a file to show details</Text></View>
                      )}
                      <br />
                      <SwitchField
                        onChange={(e) => {
                          updateIncludeDocDetails(e.target.checked);
                        }}
                        value={includeDocDetails} 
                        label={<p style={{fontSize:"0.8em", width:"50%"}}>{includeDocDetails ? undefined : "DO NOT"} set document details</p>}
                      />
                      <br />
                      <br />
                      {
                        includeDocDetails === false ? undefined :
                        <View>
                          <SelectField
                            label="Coverage Type"
                            descriptiveText="Select the type of coverage provided..."
                            value={coverageType}
                            onChange={(e) => updateCoverageType(e.target.value)}
                          >
                            <option value="">--Please Select--</option>
                            <option value="physical">Physical Damage</option>
                            <option value="liability">Liability</option>
                            <option value="both">Both</option>
                          </SelectField>
                          <br />
                          <Text>Effective date:</Text>
                          <DatePicker
                            name="Effective Date"
                            selected={insurance_effective_datetime}
                            onChange={(date) => updateEffectiveDate(date)}
                            showTimeSelect={false}
                            dateFormat="yyyy-MM-dd"
                            timeIntervals={60}
                          />
                          <br />
                          <br />
                          <Text>Expiration Date:</Text>
                          <DatePicker
                            name="Expiration Date"
                            selected={insurance_expiration_datetime}
                            onChange={(date) => updateExpirationDate(date)}
                            showTimeSelect={false}
                            dateFormat="yyyy-MM-dd"
                            timeIntervals={60}
                          />
                          <br />
                          <br />
                        </View>
                      }


                      <Button onClick={() => submitDoc()}>SUBMIT</Button>
                      <br />
                      <br />
                      <Button onClick={() => updateShowUploadDoc(false)}>CANCEL</Button>
                    </View>
                  : <Button onClick={() => updateShowUploadDoc(true)}>UPLOAD FILE</Button>
                }
            </Flex>
          </Flex>
          <Divider />
        </View>
      </Flex>
  );
}